import styled from 'styled-components';

export const SettingsCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
`;

export const CardHeading = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: #18181b;
  line-height: 1.3;
`;

export const CardNote = styled.p`
  font-size: 12px;
  color: #71717a;
  line-height: 1.6;
`;

export const SwatchRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

export const SwatchItem = styled.div<{ $color: string }>`
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: ${({ $color }) => $color};

  button {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: #18181b;
    color: #ffffff;
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  &:hover button {
    opacity: 1;
  }
`;

export const AddSwatch = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px dashed #a1a1aa;
  color: #71717a;
  cursor: pointer;

  input {
    width: 0;
    height: 0;
    opacity: 0;
    position: absolute;
  }

  &:hover {
    border-color: #0b4f9e;
    color: #0b4f9e;
  }
`;

export const PaletteRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #f1f1f1;
  background: #fbfbfc;
`;

export const FontGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
`;

export const FontPreview = styled.span<{ $family: string }>`
  display: block;
  margin-top: 4px;
  font-family: ${({ $family }) => `"${$family}", Roboto, Arial, sans-serif`};
  font-size: 18px;
  color: #3f3f46;
  line-height: 1.4;
`;
